import { UrlConstants } from "../url.constants";
export class ApiPropertyValuationPropertyObjection {
    static URL = UrlConstants.API_V2 + "PropertyValuationPropertyObjection";
    static FUNCTION_ACCEPT_OBJECTION = "AcceptObjection";
    static FUNCTION_REJECT_OBJECTION = "RejectObjection";
}
